export function balanceColor(value) {
  const balance = Number(value);
  if (balance >= 200) return 'green';
  if (balance >= 60) return 'orange';
  return 'red';
}
